import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appCapslockOn]'
})
export class CapslockOnDirective {

  @Output() capslockOn: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  @HostListener("window:click", ["$event"]) onClick(event) {
    if (event.getModifierState && event.getModifierState("CapsLock")) {
      this.capslockOn.emit(true);
    } else {
      this.capslockOn.emit(false);
    }
  }
  
  @HostListener("window:keydown", ["$event"])
  onKeyDown(event) {
    if (event.getModifierState && event.getModifierState("CapsLock")) {
      this.capslockOn.emit(true);
    } else {
      this.capslockOn.emit(false);
    }
  }
  
  @HostListener("window:keyup", ["$event"])
  onKeyUp(event) {
    if (event.getModifierState && event.getModifierState("CapsLock")) {
      this.capslockOn.emit(true);
    } else {
      this.capslockOn.emit(false);
    }
  }
}
